import React from "react";

const MembershipNumber = {
  label: {
    Any: "Membership number"
  },
  placeholder: {
    Any: "Enter your membership number"
  },
  tooltip: {
    MOL: (
      <React.Fragment>
        <p>
          You can find your membership number on your membership documents in
          the format: <strong>AXA/L1234567</strong> or <strong>1234567A</strong>
          . If you can't find it, please call us on 0800 302 9133 and we'll be
          happy to help.
        </p>
      </React.Fragment>
    ),
    HOL: "You can find your membership number on your membership documents in the format: HOL/L1234567. If you can't find it, please call us on 01202 544032 and we'll be happy to help."
  }
};

export default MembershipNumber;
